/**
 * @typedef {import('../apis/hey-api/types.gen').CompanyFeatureEnableSettings} CompanyFeatureEnableSettings
 */

/** @type {CompanyFeatureEnableSettings} */
export const DEFAULT_COMPANY_FEATURE_ENABLE_SETTINGS = {
  devicePage: {
    enableScaleStatus: true,
    enableScaleWeightData: true,
    enableScaleUniformityData: false,
  },
  farmOverviewPage: {
    enableScalePerformanceData: true,
  },
};
